import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ReleaseNotesDialogComponent } from './release-notes-dialog/release-notes-dialog.component';
import { ReleaseNotesMobileDialogComponent } from './release-notes-mobile-dialog/release-notes-mobile-dialog.component';

@NgModule({
    declarations: [ReleaseNotesDialogComponent, ReleaseNotesMobileDialogComponent],
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatProgressBarModule],
})
export class ReleaseNotesModule {}
